module.exports = __webpack_public_path__ + "img/icon-apps.24dfad2c.svg";